import { useMemo } from "react";

export const useUrlLogoutPath = () => {
  return useMemo(() => `${window.location.origin}/identity/logout`, []);
};
